import { css } from '@/styled-system/css';

/**
 * Using 'blockSize: 0' to allow as much of the photo to be right-clickable as possible (CDS-1777)
 */
export const propertyCardPhotoHeaderStyles = css.raw({
  gridArea: 'photo-top',
  blockSize: 0,
  marginBlock: 'tighter',
  marginInline: 'tighter',
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gridAutoFlow: 'column',
  justifyContent: 'space-between',
});
